module.exports = __webpack_public_path__ + "img/carousel-arrow-right-20x20.beb779b1.svg";